
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
    Card,
    Stack,
    CardContent,
    Collapse,
    Box,
    Container,
    Typography,
    CircularProgress,
    Grid,
    Pagination,
    TextField,
    Autocomplete,
    Modal,
    MenuItem,
    Button
} from '@mui/material';

import { useAxios } from '../../../../context/AxiosHookContext';
import { cargos } from '../../../../utils/lists';
import { useNotification } from "../../../../context/NotificationContext";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: "90%", md: "70%", lg: "50%" },
    bgcolor: 'background.paper',
    outline: "none",
    border: '0px',
    boxShadow: 24,
    p: 2,
    borderRadius: 4,
    height:"80vh",
    overflowX: "auto"
};


export default function PersonalitiesModalForm({ onClose, openModalEdit, funcionario = {} }) {

    const axios = useAxios();
    const [selectedValuesToEdit, selectValuesToEdit] = useState(funcionario);
    const [filterName, setFilterName] = useState("");
    const [openOrganizationList, setOpenOrganizationList] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loadingOrg, setLoadingOrg] = useState(false);
    const [organizationList, setorganizationList] = useState([]);
    const { showSnackbar } = useNotification();


    const onChangeValues = (e) => {
        selectValuesToEdit({ ...selectedValuesToEdit, [e.target.name]: e.target.value })
    }

    const savePersonality = async () => {
        try {
            setIsSubmitting(true)
            const fullName = `${selectedValuesToEdit.nombre} ${selectedValuesToEdit.apellido}`;
            const body = { ...selectedValuesToEdit, fullName: fullName }

            if (body._id) {

                await axios.put(`/personalities/update/personality/${body._id}`, body);

            } else {

                await axios.post(`/personalities/create`, body);
                selectValuesToEdit({})
            }

            showSnackbar({ severity: "success", title: "Guardado", message: "Se ha guardado la personalidad correctamente." });
            onClose();
        } catch (error) {

            const message = error?.response?.data?.message || "Ha ocurrido un error al guardar."
            showSnackbar({ severity: "error", title: "Error", message });

        } finally {
            setIsSubmitting(false);
        }
    }


    const getOrganizations = useCallback(async () => {
        try {
            const organizationApi = `/personalities/organizations?page=${1}&limit=30${filterName ? `&nombre=${filterName}` : ''}&role=${"Soporte"}`
            setorganizationList([])
            setLoadingOrg(true);
            const { data } = await axios.get(organizationApi);
            setorganizationList(data?.data?.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoadingOrg(false);
        }
    }, [axios, setLoadingOrg, filterName]);


    useEffect(() => {
        if (filterName.length > 0) {
            getOrganizations()
        }
    }, [filterName])

    useEffect(() => {

    }, [openModalEdit])

    return (
        <Modal
            open={openModalEdit}
            onClose={() => { onClose() }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>

                <Grid container spacing={2} mb={2}>

                    <Grid item xs={12} textAlign={"center"}>
                        <img src={selectedValuesToEdit?.foto || "https://observicios.gob.do/back/api/funcionarios/6391/foto"} alt=""
                            style={{
                                objectFit: "contain",
                                height: 160,
                                width: 160,
                                minHeight: 160,
                                minWidth: 160,
                                borderRadius: "100%",
                                marginLeft: "auto",
                                marginRight: "auto",
                                border: `solid 4px ${selectValuesToEdit?.estado ? '#3b5a1e' : '#6da33c'}`
                            }} />
                    </Grid>

                    <Grid item xs={12} textAlign={"center"} mt={2}>
                        <Typography variant="body1" sx={{ fontSize: "1.40rem", fontWeight: "700", color: "#5d5151" }}>{`${selectedValuesToEdit?.nombre || ""} ${selectedValuesToEdit?.apellido || ''}`}</Typography>
                    </Grid>

                    <Grid container item xs={12} spacing={2}>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.nombre} label="Nombres:" name="nombre" fullWidth onChange={onChangeValues} />
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.apellido} label="Apellidos:" name="apellido" fullWidth onChange={onChangeValues} />
                        </Grid>


                        <Grid item xs={12} md={6} mt={1}>
                            <Autocomplete
                                size="small"
                                fullWidth
                                id="support_assigned"
                                open={openOrganizationList}
                                onOpen={() => {
                                    setOpenOrganizationList(true);
                                }}
                                onClose={() => {
                                    setOpenOrganizationList(false);
                                }}
                                isOptionEqualToValue={(option, value) => option.nombre === value.nombre}
                                getOptionLabel={(option) =>
                                    option.nombre
                                }
                                options={organizationList}
                                defaultValue={{ _id: selectedValuesToEdit?.institucionId || "", nombre: selectedValuesToEdit?.institucion || "" }}
                                onChange={(_e, value) => {
                                    if (!value) {
                                        setFilterName("")
                                        return
                                    }
                                    selectValuesToEdit(
                                        {
                                            ...selectedValuesToEdit,
                                            institucionId: value._id,
                                            institucion: value.nombre,
                                            telefono: value.telefono ?  value.telefono : ""
                                        })
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        fullWidth
                                        size="small"
                                        {...params}
                                        label="Institución"
                                        onChange={(e) => {
                                            setFilterName(e.target.value)
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loadingOrg ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.telefono || ""} label="Teléfono Oficina:" name="telefono" fullWidth onChange={onChangeValues} />
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.extension || ""} label="Extensión:" name="extension" fullWidth onChange={onChangeValues} />
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.telefonoMovil || ""} label="Teléfono Movil:" name="telefonoMovil" fullWidth onChange={onChangeValues} />
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField select size="small" value={selectedValuesToEdit?.cargo || ""} label="Cargo:" name="cargo" fullWidth onChange={onChangeValues}
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200, // Altura máxima en píxeles
                                                overflowY: "auto", // Habilitar desplazamiento vertical
                                            },
                                        },
                                    },
                                }}
                            >
                                {
                                    cargos.map((value, key) => (
                                        <MenuItem value={value} key={key}>{value}</MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.area || ""} label="Unidad / Area:" name="area" fullWidth onChange={onChangeValues} />
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.categoria || ""} label="Categoría:" name="categoria" fullWidth onChange={onChangeValues} />
                        </Grid>

                        <Grid item xs={12} md={6} mt={1}>
                            <TextField size="small" value={selectedValuesToEdit?.email || ""} label="Correo electrónico:" name="email" fullWidth onChange={onChangeValues} />
                        </Grid>

                    </Grid>

                    <Grid item sm={12} textAlign={"right"} mt={3}>

                        <Button
                            variant="outlined"
                            onClick={() => {
                                onClose();
                            }}
                        >
                            cancelar
                        </Button>

                        <Button sx={{ marginLeft: 2 }}
                            variant="contained"
                            type="submit"
                            onClick={savePersonality}
                        >
                            {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                            {isSubmitting ? 'Guardando' : 'Guardar'}
                        </Button>

                    </Grid>
                </Grid>

            </Box>
        </Modal>
    )
}